import axios from 'axios'
import config from '@/config/config'

export default class TokenRequest {
  constructor() {
    this.baseUrl = config.apiBaseUrl
    this.clientId = config.clientId
    this.clientSecret = config.clientSecret
    this.alibabaCloudAppcode = config.alibabaCloudAppcode || ''
  }

  getToken(params) {
    params['grantType'] = 'password'
    params['clientId'] = this.clientId
    params['clientSecret'] = this.clientSecret
    params['scope'] = '*'
    const headers =
      this.alibabaCloudAppcode !== ''
        ? { Authorization: 'APPCODE ' + this.alibabaCloudAppcode }
        : {}
    return axios.post(`${this.baseUrl}/admin/oauth/token/`, params, {
      headers,
    })
  }
}
